import { groupByCategory, type Product } from "./catalog";
import { ProductCard } from "./ProductCard";

export function ProductGrid({ products }: { products: Product[] }) {
  const byCategory = groupByCategory(products);
  return (
    <div className="product-sections">
      {byCategory.map(([category, items]) => (
        <section key={category} className="product-section" aria-labelledby={`cat-${category}`}>
          <h2 id={`cat-${category}`} className="category-heading">
            {category}
          </h2>
          <div className="product-grid">
            {items.map((p) => (
              <ProductCard key={p.sku} product={p} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
